module.exports = __webpack_public_path__ + "assets/img/banner.c6547f97.jpg";